import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivate } from '@angular/router';
import { languages, verifyLanguage } from '../constants/app-enums';
import { TranslateService } from '@ngx-translate/core';
import { EventService } from 'src/app/services/event.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageGuard implements CanActivate {
  defaultLanguage = 'en';
  languagesList: Array<any> = languages;

  constructor( private router: Router, private translate: TranslateService, private eventService: EventService) {
    const localLang = localStorage.getItem('currentlang');
    if (localLang && verifyLanguage(localLang)) {
      this.defaultLanguage = localLang;
    } else {
      const userLang = navigator.language?.split('-')[0];
      this.defaultLanguage = userLang && verifyLanguage(userLang) ? userLang : 'en';
    }
    this.translate.setDefaultLang(this.defaultLanguage);
    this.translate.use(this.defaultLanguage);
    this.eventService.setLang(this.defaultLanguage);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const urlLanguage = route.params['lang'];
    if (!urlLanguage || this.languagesList.findIndex((entry:any) => entry.value == urlLanguage) == -1) {
      this.router.navigate([this.defaultLanguage + state.url]);
      return false;
    }
    return true;
  }
}
